export const formData = [
    {
        id: 0,
        type: 'bottomInput',
        text: 'Претендент на должность',
        placeholder: '',
    },
    {
        id: 1,
        type: 'bottomInput',
        text: 'ФИО',
        placeholder: '',
    },
    {
        id: 2,
        type: 'bottomInput',
        text: 'Дата рождения',
        placeholder: '(число, месяц, год)',
    },
    {
        id: 3,
        type: 'bottomInput',
        text: 'Место рождения',
        placeholder: '',
    },
    {
        id: 4,
        type: 'bottomInput',
        text: 'Семейное положение',
        placeholder: '',
    },
    {
        id: 5,
        type: 'bottomInput',
        text: 'Дети',
        placeholder: '(количество, возраст)',
    },
    {
        id: 6,
        type: 'bottomInput',
        text: 'Адрес регистрации',
        placeholder: '',
    },
    {
        id: 7,
        type: 'bottomInput',
        text: 'Адрес проживания',
        placeholder: '',
    },
    {
        id: 8,
        type: 'bottomInput',
        text: 'Контактный телефон',
        placeholder: '',
    },
    {
        id: 9,
        type: 'bottomInput',
        text: 'Адрес электронной почты',
        placeholder: '',
    },
    {
        id: 10,
        type: 'bottomInput',
        text: 'Судимость',
        placeholder: '(есть/нет)',
    },
    {
        id: 11,
        type: 'bottomInput',
        text: 'Минимальный уровень желаемой заработной платы',
        placeholder: '',
    },
    {
        id: 12,
        type: 'select',
        text: 'Откуда Вы узнали о конкурсе?',
        options: [
            { id: 0, text: 'рекомендация руководства Управления культуры г.Казани' },
            { id: 1, text: 'рекомендация руководства учреждения культуры' },
            { id: 2, text: 'увидел (-а) объявление' },
            { id: 3, text: 'через сайт hh.ru' },
            { id: 4, text: 'рекомендация руководства управления культуры'},
            { id: 5, text: 'другой вариант', withInput: true }
        ],
    },
    {
        id: 13,
        type: 'table',
        text: 'Образование (среднее профессиональное, высшее):',
        columns: [
            {
                id: 0,
                text: 'Год поступления и окончания',
            },
            {
                id: 1,
                text: 'Учебное заведение',
            },
            {
                id: 2,
                text: 'Факультет, специальность',
            },
            {
                id: 3,
                text: 'Город обучения',
            },
        ],
    },
    {
        id: 14,
        type: 'table',
        text: 'Опыт работы',
        columns: [
            {
                id: 0,
                text: 'Период работы (м.г/м.г)',
            },
            {
                id: 1,
                text: 'Должность, место работы',
            },
            {
                id: 2,
                text: 'Причина поиска (смены) работы',
            },
            {
                id: 3,
                text: 'Город, в котором работали',
            },
        ],
    },
    {
        id: 15,
        type: 'textarea',
        text: 'Должностные обязанности по основному месту работы',
        placeholder: '',
    },
    {
        id: 16,
        type: 'table',
        text: 'Близкие родственники (жена/муж, отец, мать, братья, сестры)',
        columns: [
            {
                id: 0,
                text: 'Степень родства',
            },
            {
                id: 1,
                text: 'Ф.И.О.',
            },
            {
                id: 2,
                text: 'Дата рождения',
            },
            {
                id: 3,
                text: 'Место работы, должность',
            },
            {
                id: 4,
                text: 'Место жительства',
            },
        ],
    },
    {
        id: 17,
        type: 'textarea',
        text: 'Перечислите три главных личных результата, достижением которых Вы гордитесь.',
        placeholder: '',
    },
    {
        id: 18,
        type: 'textarea',
        text: 'Принимали ли Вы участие в каких-либо проектах (районных, городских, республиканских)? Если да, опишите Ваш личный вклад в их реализацию. ',
        placeholder: '',
    },
    {
        id: 19,
        type: 'textarea',
        text: 'Что, на Ваш взгляд, стимулирует людей работать наиболее эффективно?',
        placeholder: '',
    },
    {
        id: 20,
        type: 'textarea',
        text: 'Какими ключевыми профессиональными навыками Вы обладаете?',
        placeholder: '',
    },
    {
        id: 21,
        type: 'textarea',
        text: 'Чем привлекает должность руководителя?',
        placeholder: '',
    },
    {
        id: 22,
        type: 'textarea',
        text: 'Что бы Вы изменили в Казанском Зооботсаде?',
        placeholder: '',
    },
    {
        id: 23,
        type: 'textarea',
        text: 'Увлечения, хобби:',
        placeholder: '',
    },
    {
        id: 24,
        type: 'checkboxAgreement',
        text: 'Я подтверждаю достоверность всего изложенного выше и не возражаю против проверки.',
        agreements: [{ id: 0, text: 'Я подтверждаю достоверность всего изложенного выше и не возражаю против проверки.' }],
        max: 1,
    },
    {
        id: 25,
        type: 'checkboxAgreement',
        text: 'Я согласен пройти оценку компетенций и не претендую на получение материалов и результатов оценки.',
        agreements: [{ id: 0, text: 'Я согласен пройти оценку компетенций и не претендую на получение материалов и результатов оценки.' }],
        max: 1,
    },
    {
        id: 26,
        type: 'checkboxAgreement',
        text: 'Я согласен на обработку персональных данных.',
        agreements: [{ id: 0, text: 'Я согласен на обработку персональных данных.' }],
        max: 1,
    },
]

export const sendInfo = {
    serviceId: 'service_j13udke',
    templateId: 'template_zim9zhl',
    publicKey: 'f0XtLro7aLnWYVrrl',
}
